import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {
  Paper,
  Box,
  Radio,
  FormControlLabel,
  Typography,
  createTheme,
  ThemeProvider,
  Button,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { ADD_SUBSCRIPTION } from "../../graphql/mutations";

const theme = createTheme({
  palette: {
    primary: {
      main: "#d2b48c", // tan color
    },
    secondary: {
      main: "#8b4513", // saddle brown color
    },
  },
  typography: {
    fontFamily: "Arial",
  },
});

const plans = [
  {
    name: "Starter",
    monthly: 0,
    yearly: 0,
  },
  {
    name: "Pro",
    monthly: 8,
    yearly: 6,
  },
  {
    name: "Expert",
    monthly: 12,
    yearly: 10,
  },
];

const NotFound = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        height: "100%",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <div style={{ padding: "0px 20px" }}>
        <h1>This payment page is either your current one or invalid</h1>
        <p>The requested page could not be found.</p>
      </div>
    </div>
  );
};
const PaymentPage = (props) => {
  const { plan: planName } = useParams();
  const plan = plans.find(
    (plan) => plan.name.toLowerCase() === planName.toLowerCase()
  );
  console.log(props);
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [addSubscription] = useMutation(ADD_SUBSCRIPTION);
  const navigate = useNavigate();
  if (props.decodedToken.role.toLowerCase() == planName.toLowerCase() || !plan)
    return <NotFound />;
  const handleApprove = (data, actions) => {
    const token = localStorage.getItem("token");
    addSubscription({
      variables: {
        token,
        userId: props.decodedToken.userId,
        role: planName,
        type: billingCycle,
      },
    }).then((newToken) => {
      console.log("New token:", newToken);
      // Set the new token in localStorage
      console.log(newToken.data.addSubscription)
      localStorage.setItem("token", newToken.data.addSubscription);
      if (planName == "starter") {
        navigate("/app/events");
      } else {
        return actions.order.capture().then(function (details) {
          // alert("Transaction completed by " + details.payer.name.given_name);
          navigate("/subscription-success/" + planName);
        });
      }
    });
  };
  const createOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: billingCycle === "monthly" ? plan.monthly : plan.yearly * 12,
          },
        },
      ],
    });
  };
  const price = billingCycle === "monthly" ? plan.monthly : plan.yearly * 12;
  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <Paper elevation={3} style={{ padding: theme.spacing(3) }}>
          <Typography variant="h4" gutterBottom>
            Complete your purchase
          </Typography>
          <Typography variant="h6" gutterBottom>
            Plan: {plan.name}
          </Typography>
          {price > 0 ? (
            <>
              <FormControlLabel
                value="monthly"
                control={
                  <Radio
                    checked={billingCycle === "monthly"}
                    onChange={() => setBillingCycle("monthly")}
                  />
                }
                label={`Monthly - $${plan.monthly}`}
              />
              <FormControlLabel
                value="yearly"
                control={
                  <Radio
                    checked={billingCycle === "yearly"}
                    onChange={() => setBillingCycle("yearly")}
                  />
                }
                label={`Yearly - $${plan.yearly * 12}`}
              />
              <PayPalButtons
                key={billingCycle}
                style={{ layout: "vertical" }}
                createOrder={createOrder}
                onApprove={handleApprove}
              />
            </>
          ) : (
            <Typography variant="body1" gutterBottom>
              This is a free plan. Would you like to remove all other plans?
              <div
                className="flex"
                style={{ gap: "20px", width: "100%", paddingTop: "10px" }}
              >
                <Button variant="contained" onClick={() => handleApprove()}>
                  Yes
                </Button>
                <Button variant="contained" href="/pricing">
                  No
                </Button>
              </div>
            </Typography>
          )}
        </Paper>
      </Box>
    </ThemeProvider>
  );
};

export default PaymentPage;
